import { inject } from "vue";
import { p as popoverPluginKey } from "../../../keys-D3gOZjD-.mjs";
const usePopoverController = () => ({ ...inject(popoverPluginKey) });
export {
  usePopoverController
};
//# sourceMappingURL=index.mjs.map
